module.exports = __webpack_public_path__ + "img/grilled_cheese.63874b34.jpg";